/**
 * Auth Api
 * Auth Xpo Api which handles all the api restful calls
 *
 * OpenAPI spec version: v3.0.1.0
 * Contact: ea@xpo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { ApplicationSecret } from '../model/applicationSecret';
import { SecretRequest } from '../model/secretRequest';
import { ValidationResult } from '../model/validationResult';
import { VendorIntegration } from '../model/vendorIntegration';
import { VendorIntegrationListItem } from '../model/vendorIntegrationListItem';
import { VendorIntegrationUpdateRequest } from '../model/vendorIntegrationUpdateRequest';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class VendorIntegrationsService {

    protected basePath = 'http://localhost';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Vendors - VendorIntegration
     * This is for getting the VendorIntegration \&quot;Application\&quot; by applicationid and subject                Sample request:                GET /vendors/{applicationId}
     * @param applicationId the application id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vendorIntegrationsApplicationIdGet(applicationId: string, observe?: 'body', reportProgress?: boolean): Observable<VendorIntegration>;
    public vendorIntegrationsApplicationIdGet(applicationId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VendorIntegration>>;
    public vendorIntegrationsApplicationIdGet(applicationId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VendorIntegration>>;
    public vendorIntegrationsApplicationIdGet(applicationId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (applicationId === null || applicationId === undefined) {
            throw new Error('Required parameter applicationId was null or undefined when calling vendorIntegrationsApplicationIdGet.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<VendorIntegration>(`${this.configuration.basePath}/vendor-integrations/${encodeURIComponent(String(applicationId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Vendors - Update Application Partially
     * This is updating VendorIntegration \&quot;Application\&quot; by applicationid and subject with Name and SupportContactEmail                Sample request:                PUT /vendors/{applicationId}                {                   \&quot;Name\&quot;:\&quot;smaple-name\&quot;,                   \&quot;SupportContactEmail\&quot;:\&quot;first.last@email.com\&quot;                }
     * @param applicationId the application id
     * @param vendorIntegrationUpdateRequest the VendorIntegrationUpdateRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vendorIntegrationsApplicationIdPut(applicationId: string, vendorIntegrationUpdateRequest?: VendorIntegrationUpdateRequest, observe?: 'body', reportProgress?: boolean): Observable<VendorIntegration>;
    public vendorIntegrationsApplicationIdPut(applicationId: string, vendorIntegrationUpdateRequest?: VendorIntegrationUpdateRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<VendorIntegration>>;
    public vendorIntegrationsApplicationIdPut(applicationId: string, vendorIntegrationUpdateRequest?: VendorIntegrationUpdateRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<VendorIntegration>>;
    public vendorIntegrationsApplicationIdPut(applicationId: string, vendorIntegrationUpdateRequest?: VendorIntegrationUpdateRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (applicationId === null || applicationId === undefined) {
            throw new Error('Required parameter applicationId was null or undefined when calling vendorIntegrationsApplicationIdPut.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<VendorIntegration>(`${this.configuration.basePath}/vendor-integrations/${encodeURIComponent(String(applicationId))}`,
            vendorIntegrationUpdateRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Vendors - Create Secret
     * This creates ApplicationSecret                Sample request:                POST /vendors/{applicationId}/secrets                {                   \&quot;Description\&quot;:\&quot;something\&quot;,                   \&quot;Secret\&quot;:\&quot;lkjsfsa*asjdh*hasd\&quot;                }
     * @param applicationId the application id
     * @param secretRequest the VendorIntegrationUpdateRequest
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vendorIntegrationsApplicationIdSecretsPost(applicationId: string, secretRequest?: SecretRequest, observe?: 'body', reportProgress?: boolean): Observable<ApplicationSecret>;
    public vendorIntegrationsApplicationIdSecretsPost(applicationId: string, secretRequest?: SecretRequest, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ApplicationSecret>>;
    public vendorIntegrationsApplicationIdSecretsPost(applicationId: string, secretRequest?: SecretRequest, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ApplicationSecret>>;
    public vendorIntegrationsApplicationIdSecretsPost(applicationId: string, secretRequest?: SecretRequest, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (applicationId === null || applicationId === undefined) {
            throw new Error('Required parameter applicationId was null or undefined when calling vendorIntegrationsApplicationIdSecretsPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<ApplicationSecret>(`${this.configuration.basePath}/vendor-integrations/${encodeURIComponent(String(applicationId))}/secrets`,
            secretRequest,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Vendors - Delete Secret
     * This deletes the secret from \&quot;Application\&quot; by applicationid and secretid                Sample request:                DELETE /vendors/{applicationId}/secrets/{secretId}
     * @param applicationId the application id
     * @param secretId the secret Id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vendorIntegrationsApplicationIdSecretsSecretIdDelete(applicationId: string, secretId: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public vendorIntegrationsApplicationIdSecretsSecretIdDelete(applicationId: string, secretId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public vendorIntegrationsApplicationIdSecretsSecretIdDelete(applicationId: string, secretId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public vendorIntegrationsApplicationIdSecretsSecretIdDelete(applicationId: string, secretId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (applicationId === null || applicationId === undefined) {
            throw new Error('Required parameter applicationId was null or undefined when calling vendorIntegrationsApplicationIdSecretsSecretIdDelete.');
        }
        if (secretId === null || secretId === undefined) {
            throw new Error('Required parameter secretId was null or undefined when calling vendorIntegrationsApplicationIdSecretsSecretIdDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<any>(`${this.configuration.basePath}/vendor-integrations/${encodeURIComponent(String(applicationId))}/secrets/${encodeURIComponent(String(secretId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Vendors - All
     * This is for getting all the Applications by vendor Subject                Sample request:                GET /vendors
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public vendorIntegrationsGet(observe?: 'body', reportProgress?: boolean): Observable<Array<VendorIntegrationListItem>>;
    public vendorIntegrationsGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<VendorIntegrationListItem>>>;
    public vendorIntegrationsGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<VendorIntegrationListItem>>>;
    public vendorIntegrationsGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<VendorIntegrationListItem>>(`${this.configuration.basePath}/vendor-integrations`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}



// WEBPACK FOOTER //
// /ng-app/src/apiModule/api/vendorIntegrations.service.ts